module.exports = __webpack_public_path__ + "img/sum.d41d7ed1.png";